





































import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';

import { ICompanyType } from '../../models';
import { BaseDetail } from '../Base/BaseDetail';

const namespace = 'companyType';
const ns = { namespace };

@Component
export default class CompanyTypeDetail extends BaseDetail<ICompanyType> {
  namespace = namespace;
  @State('entities', ns) entities: Record<string, ICompanyType>;
  @Action('createEntity', ns) createEntity: any;
  @Action('getEntity', ns) getEntity: any;
  @Action('updateEntity', ns) updateEntity: any;
  @Action('deleteEntity', ns) deleteEntity: any;
  mounted() {
    this.loadEntity();
  }
}
